var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapToSee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:tap-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.02649 9.8715L6.53324 11.1713V4.6185C6.53324 3.9315 7.08599 3.375 7.76849 3.375C8.45099 3.375 9.00374 3.9315 9.00374 4.6185V7.97325L11.1127 8.313C12.474 8.5185 13.155 8.6205 13.6342 8.91C14.4262 9.38775 15 10.1047 15 11.1525C15 11.8815 14.8207 12.3705 14.385 13.6852C14.1097 14.5192 13.971 14.9362 13.746 15.2662C13.3762 15.8088 12.8292 16.2057 12.1987 16.389C11.8162 16.5 11.3797 16.5 10.506 16.5H9.76574C8.60399 16.5 8.02349 16.5 7.50674 16.2855C7.41411 16.2466 7.3235 16.203 7.23524 16.155C6.74399 15.8865 6.37799 15.4335 5.64524 14.526L3.27524 11.589C3.0984 11.3695 3.00147 11.0964 3.00038 10.8146C2.99929 10.5327 3.0941 10.2588 3.26924 10.038C3.37161 9.90872 3.49907 9.80149 3.64397 9.72275C3.78886 9.64402 3.94818 9.59541 4.11235 9.57986C4.27651 9.5643 4.44213 9.58212 4.59923 9.63224C4.75633 9.68236 4.90167 9.76375 5.02649 9.8715Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7369 4.5C10.7369 3.70435 10.4209 2.94129 9.85826 2.37868C9.29565 1.81607 8.53259 1.5 7.73694 1.5C6.94129 1.5 6.17823 1.81607 5.61562 2.37868C5.05301 2.94129 4.73694 3.70435 4.73694 4.5",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapToSee);
export default __webpack_public_path__ + "static/media/tap-to-see.871356b67ef89db68f3566f997615b78.svg";
export { ForwardRef as ReactComponent };